import { apiHelper, sessionHelper } from "@/utils";
import { certificateLayoutPayload } from "@/models/api/certificate.model";
import { API } from "@/constants";
const API_URL = `${API.BASE_URL_API}/v1`;

export function certificateFormData(data, updating = false) {
  const body = new FormData();
  if (updating) body.append("_method", "PUT");
  body.append("name", data.name.trim());
  body.append(
    "layout_config",
    JSON.stringify(certificateLayoutPayload(data.layoutConfig)),
  );
  if (data.file instanceof File) body.append("file", data.file);
  return body;
}
export async function certificatePdfBlob(blob) {
  if (blob instanceof Blob && (await blob.slice(0, 5).text()) === "%PDF-")
    return blob;
  let data = blob;
  if (blob instanceof Blob) {
    try {
      data = JSON.parse(await blob.text());
    } catch (error) {
      throw new Error("Invalid PDF response.");
    }
  }
  const details = data?.errors || data?.error;
  const message =
    typeof details === "string"
      ? details
      : details && typeof details === "object"
      ? Object.values(details).flat().join(" ")
      : "";
  throw new Error(message || data?.message || "Invalid PDF response.");
}
export const certificateService = {
  async preview(uuid, recipient) {
    if (sessionHelper.getPermissionLevel("cert_admin") < 1)
      return Promise.reject(new Error("Certificate permission denied."));
    try {
      const result = await apiHelper(API_URL).post(
        `/certs/${encodeURIComponent(uuid)}/preview`,
        recipient,
        {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
            "Content-Type": "application/json",
          },
        },
      );
      return await certificatePdfBlob(result);
    } catch (error) {
      if (error?.response?.data instanceof Blob)
        return certificatePdfBlob(error.response.data);
      throw error;
    }
  },
  getAll(page = 1, size = 15) {
    if (sessionHelper.getPermissionLevel("cert_admin") < 1)
      return Promise.reject(new Error("Certificate permission denied."));
    return apiHelper(API_URL).get("/certs", { params: { page, size } });
  },
  show(uuid) {
    if (sessionHelper.getPermissionLevel("cert_admin") < 1)
      return Promise.reject(new Error("Certificate permission denied."));
    return apiHelper(API_URL).get(`/certs/${encodeURIComponent(uuid)}`);
  },
  store(data) {
    if (sessionHelper.getPermissionLevel("cert_admin") < 2)
      return Promise.reject(new Error("Certificate permission denied."));
    return apiHelper(API_URL).post("/certs", certificateFormData(data));
  },
  update(uuid, data) {
    if (sessionHelper.getPermissionLevel("cert_admin") < 2)
      return Promise.reject(new Error("Certificate permission denied."));
    return apiHelper(API_URL).post(
      `/certs/${encodeURIComponent(uuid)}`,
      certificateFormData(data, true),
    );
  },
  updateStatus(uuid, isActive) {
    if (sessionHelper.getPermissionLevel("cert_admin") < 2)
      return Promise.reject(new Error("Certificate permission denied."));
    return apiHelper(API_URL).patch(`/certs/${encodeURIComponent(uuid)}`, {
      is_active: [true, 1, "1"].includes(isActive),
    });
  },
};
